import { GroupContentState, GroupContentStateModel } from './group-content.state';

import { Selector } from '@ngxs/store';

export class GroupContentSelector {
  @Selector([GroupContentState])
  static group(state: GroupContentStateModel): GroupContentStateModel {
    return state;
  }
}
